const StatesData = {
  statesData: [{
    index: 0,
    title: '平台列表',
    first_model: [
        { value: 'gameList', label: '游戏平台列表', index: 0 },
    ],
  }, {
    index: 1,
    title: '游戏设置',
    first_model: [
      {
        title: '弹窗公告',
        name: [
          { value: 'xyxNoticeConfig', label: '弹窗活动', index: 1, promise: 3 },
          { value: 'xyxNoticeConfigOld', label: '弹窗活动(旧)', index: 1, promise: 3 },
          { value: 'mindGamesAdSet', label: '智运会广告配置', index: 1, promise: 3 },
          { value: 'advertConfig', label: '广告ID配置', index: 1, promise: 3 },
        ],
      },
      {
        title: '其他设置',
        name: [
          { value: 'gameAreaSortConfig', label: '子游戏顺序配置', index: 1, promise: 2 },
          { value: 'userLabelConfig', label: '用户标签配置', index: 1, promise: 3 },
          { value: 'userLabelConfigNew', label: '用户标签配置2.0', index: 1, promise: 3 },
          { value: 'featureToggle', label: '功能开关', index: 1, promise: 3 },
          { value: 'imgSet', label: '图片配置', index: 1, promise: 3 },
          { value: 'iconKeySet', label: '图标', index: 1, promise: 2 },
          { value: 'channelAndPropTag', label: '渠道配置', index: 1, promise: 3 },
          { value: 'crossPlatformCopySet', label: '功能复制', index: 1, promise: 1 },
          { value: 'platformVxConfig', label: '客服微信配置', index: 1, promise: 3 },
          { value: 'qifuActivitySwtichSet', label: '祈福活动开关', index: 1, promise: 3 },
          { value: 'channelConfig', label: ' 用户注册途径配置', index: 1, promise: 3 },
          { value: 'gameAreaSwitch', label: '子游戏开关', index: 2, promise: 2 },
          { value: 'gameAreaConfig', label: '游戏子号配置', index: 1, promise: 3 },
          { value: 'wxBuyConfig', label: '支付渠道配置', index: 1, promise: 3 },
          { value: 'newLeadConfig', label: ' 新手引导列表', index: 1, platformPermiseList: [78], promise: 3 },
        ],
      },
    ],
  },
  {
    index: 10,
    title: '比赛场',
    first_model: [
      {
        title: '',
        name: [
            { value: 'matchConfigNew', label: '比赛场配置', index: 10, promise: 2 },
            { value: 'matchWhiteList', label: '观战白名单', index: 10, platformPermiseList: [78], promise: 3 },
        ],
      },
    ],
  },
  {
    index: 11,
    title: '金币场',
    first_model: [
      {
        title: '',
        name: [
          { value: 'goldIndex', label: '金币场配置', index: 10, promise: 3 },
        ],
      },
      {
        title: '体验配置',
        name: [
            { value: 'crowdSet', label: '人群配置', index: 11, promise: 3 },
            { value: 'crowdStrategySet', label: '人群-策略', index: 11, promise: 3 },
            { value: 'strategySet', label: '策略配置', index: 11, promise: 3 },
            { value: 'strategyEditSet', label: '策略详情配置', index: 11, promise: 3 },
            { value: 'goldShareSet', label: '分享配置', index: 11, promise: 3 },
        ],
      },
    ],
  },
  {
    index: 12,
    title: '挑战赛',
    first_model: [
      {
        title: '',
        name: [
            { value: 'propertyValue', label: '道具价值', index: 12, promise: 2 },
            { value: 'aiSet', label: 'ai配置', index: 12, promise: 2 },
            { value: 'challengeGameSet', label: '挑战赛配置', index: 12, promise: 2 },
            { value: 'challengeLevelSet', label: '关卡配置', index: 12, promise: 2 },
            { value: 'otherConfig', label: '其他配置', index: 12, promise: 2 },
        ],
      },
    ],
  },
  {
    index: 13,
    title: '道具/商城',
    first_model: [
      {
        title: '卡密配置',
        name: [
            { value: 'cardSecretTypeSet', label: '卡密类型配置', index: 13, promise: 2 },
            { value: 'cardSecretChannelSet', label: '卡密渠道配置', index: 13, promise: 2 },
            { value: 'cardSecretBeingSet', label: '卡密订单及兑换信息', index: 13, promise: 3 },
            { value: 'cardSecretStockSet', label: '卡密库存信息', index: 13, promise: 3 },
        ],
      },
      {
        title: '道具配置',
        name: [
            { value: 'propTypeSet', label: '道具类型配置', index: 13, promise: 1 },
            { value: 'propFieldSet', label: '道具字段配置', index: 13, promise: 2 },
            { value: 'debrisSet', label: '碎片道具组', index: 13, promise: 2 },
            { value: 'propSet', label: '道具配置', index: 13, promise: 1 },
        ],
      },
      {
        title: '商城配置',
        name: [
            { value: 'ddzLotteryExchangeSet', label: '斗地主兑换券', platformPermiseList: [78], index: 13, promise: 2 },
            { value: 'propTagSet', label: '商品标识配置', index: 13, promise: 1 },
            { value: 'propTagSet2', label: '商品标识配置2.0', index: 13, promise: 1 },
            { value: 'shopPageTypeSet', label: '商城页签配置', index: 13, promise: 1 },
            // { value: 'shopPageTypeSet2', label: '商城页签配置2.0', index: 13, promise: 1 },
            { value: 'shopPageTypeSet3', label: '商城页签配置2.0', index: 13, promise: 1 },
            { value: 'shopMallGiftSet', label: '商城礼包配置', index: 13, promise: 1 },
            { value: 'shopMallGiftSet2', label: '商城礼包配置2.0', index: 13, promise: 1 },
            { value: 'shopMallSet', label: '商城配置2.0', index: 13, promise: 2 },
            { value: 'mallOperationRecord', label: '商城操作记录', index: 13, promise: 2 },
            { value: 'shopMallSetOld', label: '商城配置', index: 13, promise: 1 },
            // { value: 'mallGiftBagSet', label: '商城礼包配置2.0', index: 13, promise: 2 },
            // { value: 'mallSetNew', label: '商城配置2.0', index: 13, promise: 2 },
            // { value: 'specialExchangeShop', label: '专题赛兑换商店2.0', index: 13, promise: 2 },
            // { value: 'mallSet', label: '商城配置1.0(废弃)', index: 13, promise: 2 },
            { value: 'exchangeShop', label: '兑换商店', index: 13, promise: 2 },
            { value: 'dressUpExperience', label: '装扮体验礼包配置', index: 13, promise: 2 },
        ],
      },
      {
        title: '其他配置',
        platformPermiseList: [78],
        name: [
            { value: 'vipConfig', label: 'VIP配置', index: 13, platformPermiseList: [78], promise: 2 },
            { value: 'weeksCard', label: '周卡配置', index: 13, platformPermiseList: [78], promise: 2 },
        ],
      },
    ],
  },
  {
    index: 2,
    title: '游戏模块',
    first_model: [
      {
        title: '用户信息管理',
        name: [
          { value: 'userTagsSet', label: '用户标签', index: 2, promise: 3 },
          { value: 'questionnaireStuation', label: '问卷情况', index: 2, promise: 3 },
          { value: 'propsWholesale', label: '道具批量发放', index: 2, promise: 1 },
          { value: 'messageWholesale', label: '短信批量发放', index: 2, promise: 2 },
          { value: 'userOperationLog', label: '操作日志', index: 2, promise: 3 },
        ],
      },
      {
        title: '任务配置',
        name: [
          { value: 'taskPoolSetNew', label: '任务配置', index: 2, promise: 2 },
        ],
      },
      {
        title: '排位头衔系统',
        name: [
          { value: 'seasonThemeSet', label: '赛季主题配置', index: 1, promise: 2 },
          { value: 'bigLevelSet', label: '段位配置', index: 1, promise: 2 },
          { value: 'rankTitleSet', label: '赛季段位配置', index: 1, promise: 2 },
        ],
      },
      {
        title: '主线引导',
        platformPermiseList: [78],
        name: [
          { value: 'victoryFluCard', label: '胜局福卡', index: 2, platformPermiseList: [78], promise: 2 },
          { value: 'winningStreakAward', label: '连胜奖励配置', index: 2, platformPermiseList: [78], promise: 2 },
          { value: 'sevenDayTaskConfig', label: '主线引导任务配置', index: 2, platformPermiseList: [78], promise: 2 },
        ],
      }, {
        title: '自定义事件',
        name: [
          { value: 'behaviorSetTotal', label: '事件配置(新)', index: 2, promise: 2 },
        ],
      }, {
        title: '小程序充值配置 ',
        name: [
          { value: 'iosFriendGive', label: 'IOS好友赠送', index: 2, promise: 2 },
        ],
      },
      {
        title: '平台跳转配置',
        name: [
          { value: 'intermodalTransportation', label: '平台跳转/联运', promise: 2 },
          { value: 'sameSubject', label: '平台跳转/同主体', promise: 2 }
        ],
      },
      {
        title: '中至农场',
        name: [
          { value: 'configOfZzFarm', label: '农场基础配置', promise: 2 },
        ]
      }
    ],
  },
  {
    index: 5,
    title: '运营活动',
    first_model: [
      {
        title: '',
        name: [
          { value: 'regressionConfiguration', label: '回归配置', index: 5, promise: 2 },
          { value: 'operationConfiguration', label: '运营活动配置', index: 5, promise: 2 },
          { value: 'drawLotSet', label: '祈愿(求签)配置', index: 5, promise: 2 },
          { value: 'drawLotSet2', label: '祈愿(求签)配置2.0', index: 5, promise: 2 },
          { value: 'drawLotSet3', label: '祈愿(求签)配置2.1', index: 5, promise: 2 },
          { value: 'parySet', label: '祝福(祈福)配置', index: 5, promise: 2 },
          { value: 'advTouchConfiguration', label: '广告误触配置', index: 5, promise: 2 },
          { value: 'matchConfiguration', label: '对局有礼配置', index: 5, promise: 2 },
          { value: 'shuffleConfiguration', label: '洗牌配置', index: 5, promise: 3},
          { value: 'strongMissileConfiguration', label: '活动强弹配置', index: 5, promise: 2},
          { value: 'groupFriendRedPack', label: '天降红包', index: 5, promise: 2 },
        ],
      },
      {
        title: '春节活动',
        name: [
          { value: 'newYearRedEnvelopesSet', label: '新年红包奖励配置', index: 5, promise: 2 },
          { value: 'newYearSeckill', label: '新春秒杀奖励配置', index: 5, promise: 2 },
          { value: 'newYearGiftConfig', label: '新春礼包奖励配置', index: 5, promise: 2 },
          { value: 'newYearFirecrackerSet', label: '新春鞭炮奖励配置', index: 5, promise: 2 },
        ],
      },
      {
        title: '其他活动奖励',
        name: [
          { value: 'timingAwardSet', label: '定时奖励', index: 5, promise: 2 },
          { value: 'laXinSet', label: '拉新配置', index: 5, promise: 3 },
          { value: 'laXinActivity', label: '拉新活动', index: 5, promise: 3 },
          { value: 'getFriends', label: '呼朋唤友拉新活动', index: 5, promise: 3 },
          { value: 'praysAdConfig', label: '祈福广告', index: 5, promise: 3 },
          { value: 'luckyTurntable', label: '好运大转盘', index: 5, promise: 3 },
          { value: 'cardRecharge', label: '卡片充值福利', index: 5, promise: 3 },
        ],
      },
      {
        title: '可配置活动模板',
        name: [
          { value: 'activityGroupSet', label: '活动组配置', index: 5, promise: 2 },
          { value: 'childActivitySet', label: '子活动配置', index: 5, promise: 2 },
        ],
      },
      {
        title: '头衔系统',
        platformPermiseList: [78],
        name: [
          { value: 'titleLevelSet', label: '头衔配置', index: 5, platformPermiseList: [78], promise: 2 },
          { value: 'seasonRankSet', label: '赛季排名奖励配置', index: 5, platformPermiseList: [78], promise: 2 },
        ],
      },
      {
        title: '余额提现',
        platformPermiseList: [78],
        name: [
          { value: 'balanceWithdrawSet', label: '余额提现配置', index: 5, platformPermiseList: [78], promise: 2 },
          { value: 'telChargeRecord', label: '余额提现话费', index: 5, platformPermiseList: [78], promise: 3 },
        ],
      },
      {
        title: '赏金令配置',
        platformPermiseList: [78],
        name: [
          { value: 'permitPropSet', label: '赏金令配置', index: 5, platformPermiseList: [78], promise: 2 },
        ],
      },
      {
        title: '百元提现',
        platformPermiseList: [78],
        name: [
          { value: 'hundredMatchConfig', label: '百元赛配置', index: 5, platformPermiseList: [78], promise: 2 },
          { value: 'rankListConfig', label: '排行榜配置', index: 5, platformPermiseList: [78], promise: 2 },
          { value: 'randomRedPacket', label: '百元赛礼包配置', index: 5, platformPermiseList: [78], promise: 2 },
        ],
      },
      {
        title: '记牌器',
        name: [
          { value: 'jiPaiQiConfig', label: '记牌器配置', index: 5, promise: 2 },
        ],
      },
      {
        title: '投放码',
        name: [
          { value: 'putCode', label: '投放码配置', index: 5, promise: 2 },
        ],
      },
      {
        title: '大转盘',
        name: [
          { value: 'turntableSetNew2', label: '大转盘配置', index: 5, promise: 2 },
          { value: 'turntableSetNew3', label: '大转盘配置（新）', index: 5, promise: 2 },
          { value: 'qqTurntableSet', label: 'QQ大转盘', index: 5, platformPermiseList: [78], promise: 2 },
        ],
      }, {
        title: '送金币活动',
        name: [
          { value: 'verbSet', label: '送金币活动设置', index: 5, promise: 2 },
        ],
      }, {
        title: '任务活动',
        name: [
          { value: 'taskSet', label: '签到任务配置', index: 5, platformPermiseList: [78], promise: 2 },
          { value: 'newUser7DaysAward', label: '新人七日礼包配置', index: 5, promise: 2 },
        ],
      }, {
        title: '签到活动',
        name: [
          { value: 'taskSetNew', label: '签到配置New', index: 5, platformPermiseList: [78], promise: 2 },
          { value: 'tomorrowAward', label: '明日有礼', index: 5, platformPermiseList: [78], promise: 2 },
          { value: 'sevenDaySignSet', label: '七日签到活动', index: 5, promise: 2 },
        ],
      }, {
        title: '闯关配置',
        platformPermiseList: [78],
        name: [
          { value: 'gameChuangGuanConfig', label: '闯关配置', index: 5, platformPermiseList: [78], promise: 2 },
          { value: 'gameStageConfigSet', label: '关卡配置', index: 5, platformPermiseList: [78], promise: 2 },
        ],
      },
      {
        title: '广播',
        platformPermiseList: [78],
        name: [
          { value: 'broadcastConfig', label: '广播配置', index: 5, promise: 3, platformPermiseList: [78] },
        ],
      },
    ],
  },

  {
    index: 3,
    title: '牌库配置',
    first_model: [
      {
        title: '控牌策略',
        name: [
          { value: 'cardControlStrategy', label: '扑克发牌配置', index: 3, promise: 2 },
          { value: 'controlCardConfig', label: '麻将发牌配置（手牌）', index: 3, promise: 2 },
          { value: 'controlFractionConfig', label: '麻将发牌配置（分数）', index: 3, promise: 2 },
          { value: 'dealTactics', label: '麻将发牌策略', index: 3, promise: 2 },
        ],
      },
      {
        title: '麻将牌库',
        name: [
          { value: 'mahjongWinWaySet', label: '胡法配置', index: 3, promise: 2 },
        ],
      },
      {
        title: '牌库应用',
        name: [
          { value: 'drillPokerUseConfigNew', label: '牌库组应用', index: 2, promise: 2 },
          { value: 'drillPokerTestSet', label: '牌库测试', index: 2, promise: 2 },
          { value: 'pokerSetConfig', label: '牌库配置', index: 2, promise: 2 },
          { value: 'drillPokerSwitch', label: '训练牌库开关配置', index: 2, promise: 2 },
        ],
      },
      {
        title: '机器人金币控制',
        name: [
          { value: 'robotGoldControl', label: '场次配置', index: 3, promise: 2 },
        ],
      },
    ],
  },
  {
    index: 8,
    title: '信息推送',
    first_model: [
      {
        title: '',
        name: [
          { value: 'radioPush', label: '广播推送', index: 8, promise: 2 },
        ]
      },
      {
        title: '客服推送',
        name: [
            { value: 'pubLinkList', label: '客服推送', index: 8, promise: 3 },
            { value: 'mailconfig', label: '邮件系统', index: 8, promise: 1 },
        ],
      },
      {
        title: '订阅推送',
        name: [
            { value: 'pubEvent', label: '订阅事件列表', index: 8, promise: 3 },
            { value: 'moduleList', label: '消息模版', index: 8, promise: 3 },
            { value: 'pushModel', label: '消息推送', index: 8, promise: 3 },
        ],
      },
    ],
  },
  {
    index: 14,
    title: '全局配置',
    first_model: [
      {
        title: '',
        name: [
          { value: 'channelAndPropTag2', label: '渠道配置2.0', index: 14, promise: 3 },
          { value: 'shareCardDeck', label: '分享配置', index: 14, promise: 3 },
          { value: 'privilegeConfig', label: '特权配置', index: 14, promise: 3 },
        ],
      },
    ],
  },
  ],
  // 不需要判断权限的页面
  toNames: ['Login', 'gameList', 'noPermission', 'permissionObj', 'NotFind'],
  // 需要获取子游戏的页面(除gameList外)必须同时出现在 statesData 和 needGameArea 中, 否则页面无法获取
  // userBoardsTime, getGameAreaList, taskConfig 不在statesData
  needGameArea: ['userBoardsTime', 'getGameAreaList', 'gameStageConfigSet', 'taskConfig', 'awardConfig', 'goldIndex', 'sevenDayTaskConfig', 'strategySet', 'gameChuangGuanConfig', 'matchConfig'],
}

export default StatesData
